import { authConfig } from '@src/auth/config';
import { apiSlice } from '../api/apiSlice';
import { ROUTE_AUTH_FULL_PATH } from '@src/constants/URLS.const';
import {
  AuthParams,
  AuthResponse,
  ForgotPasswordParams,
  SignUpParams,
  UserInfoParams,
  UserInfoResponse,
} from './userApiTypes';

const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation<AuthResponse, AuthParams>({
      query: ({ email, password }) => ({
        url: `${authConfig.domain}/oauth/token`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          grant_type: authConfig.grantType,
          client_id: authConfig.clientId,
          audience: authConfig.audience,
          username: email,
          password,
          scope: authConfig.scope,
        },
      }),
    }),

    getUserInfo: builder.mutation<UserInfoResponse, UserInfoParams>({
      query: ({ access_token }) => ({
        url: `${authConfig.domain}/userinfo`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }),
    }),

    signUp: builder.mutation<AuthResponse, SignUpParams>({
      query: (data) => ({
        url: `${authConfig.domain}/dbconnections/signup`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          client_id: authConfig.clientId,
          email: data.email,
          password: data.password,
          connection: authConfig.connection,
          user_metadata: { referralCode: data.referralCode },
        },
      }),
    }),

    forgotPassword: builder.mutation<void, ForgotPasswordParams>({
      query: ({ email }) => ({
        url: `${authConfig.domain}/dbconnections/change_password`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          client_id: authConfig.clientId,
          email,
          connection: authConfig.connection,
        },
      }),
    }),

    logoutUser: builder.mutation<void, void>({
      queryFn: () => {
        window.location.href = `${authConfig.domain}/v2/logout?client_id=${authConfig.clientId}&returnTo=${ROUTE_AUTH_FULL_PATH}`;
        return { data: undefined };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoginUserMutation,
  useSignUpMutation,
  useForgotPasswordMutation,
  useLogoutUserMutation,
  useGetUserInfoMutation,
} = userApiSlice;
